// 引入axios
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { handleError } from 'vue';
import router from '@/router';
// 创建axios实例

// let baseUrl = "http://localhost:9999/api/";
let baseUrl="https://hshbyg.cn/api/";
const httpService = axios.create({
  baseURL: baseUrl,
  // 请求超时时间
  timeout: 4000 // 需自定义
});


//添加请求和响应拦截器
// 添加请求拦截器
httpService.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.token = window.sessionStorage.getItem('token');
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
httpService.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  if (error.response) {
    const { status } = error.response;
    // if (status === 500) {
    //   console.log("服务器错误，请联系管理员！");
    //   console.log('router 实例', router)
    //   console.log('router.currentRoute.value', router.currentRoute.value)
    //   router.replace('/login')
    // }
    if (status === 500) {
      ElMessage.error('认证过期/服务器故障，请重新登录')
      sessionStorage.clear() // ✅ 清 token
      router.replace('/login')
      return new Promise(() => { })
    }
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});

/*网络请求部分*/

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'get',
      params: params
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

export function getServerUrl() {
  return baseUrl;
}

export default {
  get,
  post,
  fileUpload,
  getServerUrl,
}

